uniform sampler2D uTexture;
uniform vec2 uMouse;
uniform float time;
uniform vec2 uResolution; // Add this uniform for screen resolution
varying vec2 vUv;
varying float vCircleIntensity;

// Improved noise function
vec3 mod289(vec3 x) { return x - floor(x * (1.0 / 289.0)) * 289.0; }
vec2 mod289(vec2 x) { return x - floor(x * (1.0 / 289.0)) * 289.0; }
vec3 permute(vec3 x) { return mod289(((x*34.0)+1.0)*x); }

float snoise(vec2 v) {
    const vec4 C = vec4(0.21, 0.36,
             -0.577, 0.024);
    vec2 i  = floor(v + dot(v, C.yy));
    vec2 x0 = v -   i + dot(i, C.xx);
    vec2 i1 = (x0.x > x0.y) ? vec2(1.0, 0.0) : vec2(0.0, 1.0);
    vec4 x12 = x0.xyxy + C.xxzz;
    x12.xy -= i1;
    i = mod289(i);
    vec3 p = permute( permute( i.y + vec3(0.0, i1.y, 1.0))
        + i.x + vec3(0.0, i1.x, 1.0));
    vec3 m = max(0.5 - vec3(dot(x0,x0), dot(x12.xy,x12.xy),
        dot(x12.zw,x12.zw)), 0.0);
    m = m*m;
    m = m*m;
    vec3 x = 2.0 * fract(p * C.www) - 1.0;
    vec3 h = abs(x) - 0.5;
    vec3 ox = floor(x + 0.5);
    vec3 a0 = x - ox;
    m *= 1.792 - 0.853 * (a0*a0 + h*h);
    vec3 g;
    g.x  = a0.x  * x0.x  + h.x  * x0.y;
    g.yz = a0.yz * x12.xz + h.yz * x12.yw;
    return 130.0 * dot(m, g);
}

// Random function
float random(vec2 st) {
    return fract(sin(dot(st.xy, vec2(12.9,78.2))) * 43758.5);
}

vec3 randomColor(vec2 st) {
    return vec3(
        random(st),
        random(st + 1.0),
        random(st + 2.0)
    );
}

void main() {
    vec2 uv = vUv;
    vec4 texColor = texture2D(uTexture, uv);
    
    // Convert mouse position from screen coordinates to UV space
    vec2 mouseUV =  (uMouse * 0.5) + 0.5 / 1.0;
    
    // Parameters for lines
    float lineThickness = 0.005;
    float lineSpacing = 0.05;
    float distortionStrength = 0.0;
    float distortionRadius = 1.0;
    
    // Calculate moving line position
    float yPos = mod(uv.y - time * 0.05, lineSpacing);
    
    // Calculate distance to mouse in UV space
    float mouseDist = distance(vUv, (uMouse * 0.5) + 0.5);
    
    // Calculate distortion
    float distortion = 0.0;
    if (mouseDist < distortionRadius) {
        distortion = sin((1.0 - mouseDist / distortionRadius) * 3.14159) * distortionStrength;
    }
    
    // Apply distortion to y-position
    yPos += distortion * smoothstep(lineThickness, 0.0, abs(uv.x - mouseUV.x));
    
    // Create line
    float line = smoothstep(lineThickness, 0.0, abs(yPos - lineSpacing * 0.5));
    
    // Determine if the line is intersecting with the mouse
    float lineIndex = floor((uv.y - time * 0.1) / lineSpacing);
    float mouseLineIndex = floor((mouseUV.y - time * 0.1) / lineSpacing);
    bool isIntersecting = abs(lineIndex - mouseLineIndex) < 0.5 && mouseDist < distortionRadius;
    
    // Generate random color for intersecting lines
    vec3 lineColor;
    if (isIntersecting) {
        lineColor = randomColor(vec2(lineIndex, 1.0));
    } else {
        lineColor = vec3(0.01); // White for non-intersecting lines
    }
    
    // Mix line color with texture
    vec3 finalColor = mix(texColor.rgb, lineColor, line - 1.5);
    
    // Add vCircleIntensity effect
    finalColor -= vec3(0.2, 0.1, 0.3) * vCircleIntensity * 0.0;
    
    csm_DiffuseColor = vec4(finalColor, texColor.a);
}